export const NOT_FOUND_ROUTE_PATH = '*'; // docs - https://reactrouter.com/docs/en/v6/getting-started/overview#not-found-routes

// export const GO_BACK_DELTA = -1; // learn more - https://github.com/remix-run/react-router/blob/main/packages/react-router/lib/hooks.tsx#L125
